
    <div class="wrapper">
        <div class="container px-0">
            <h5 class="main-title">Madison Medical & Sports</h5>
            <!-- <span class="text-default">Best Practice <span class="small">1 of 12</span> </span> -->
            <div class="main-info">
                <!-- <strong>Insurance Details</strong> [(ngModel)]="madisonPHIdetails. disclosurE_DESCRIPTION" -->
               </div>
            <div class="px-3 pb-3">
                <div class="form-row">
                <div class="col-md-4">
                    <div class="form-group ">
                      <div class="form-group">
                        <label>Who may we thank for referring our office? </label>
                        <input type="text" class="form-control" placeholder="Type here" [(ngModel)]="patientIntakeData.refPerson"> 
                      </div>
                    </div>
                  </div> 
                   
                  <div class="col-md-4">
                    <div class="form-group">
                        <label>What is your reason for visit?</label>
                      <div class="form-select form-floating">
                        <select translate="no" class="form-control" (change)="checkInjuryStatus($event.target)">
                          <option value="" disabled selected>Select</option>
                          <option value="Hormone/ wellness">Hormone/ wellness</option>
                          <option value="Podiatry">Podiatry</option>
                          <option value="Physical therapy">Physical therapy</option>
                          <option value="New primary">New primary</option>
                          <option value="Annual physical">Annual physical</option>
                          <option value="IV">IV</option>
                          <option value="New primary">New primary</option>
                          <option value="Injury">Injury</option>
                        </select>  
                      </div>
                    </div>
                  </div>
                  
                  <div class="col-md-4">
                    <div class="form-group ">
                      <div class="form-group">
                        <label>How long has this been going on? </label>
                        <input type="text" class="form-control" placeholder="Type here"  [(ngModel)]= "patientIntakeData.duration"> 
                      </div>
                    </div>
                  </div> 
                </div> 
            </div>

        </div>
    </div>
    <footer class="p-3">
        <div class="container p-0">
            <div class="text-right">
                <!-- <button type="button" class="btn btn-primary" data-toggle="modal" data-target="#ConsentForm1" >Next</button> -->
                  <button type="button" class="btn btn-primary" data-toggle="modal" (click)= "Injured()">Next</button>
            </div>
        </div>
    </footer>




